<template>
  <Modal v-model="templateModel" title="批量导入购物车" footer-hide width="480px"  :mask-closable="false">
    <Form ref="templateForm" :model="templateForm" :rules="ruleValidate" :label-width="100"
          style="padding-bottom: 20px">
      <div><a @click="downLoding" class="mr20 colorBlue">下载模板</a></div>
      <FormItem label="选择店铺:" prop="sellerTenantId">
        <div class="flex" style="justify-content: flex-start;">
          <Select v-model="templateForm.sellerTenantId" class="selectW80" :loading="loading"  filterable remote :remote-method="remoteMethod" placeholder="请输入店铺名称" >
            <Option v-for="item in shopList" :key="item.id" :value="item.id" :label="item.tenantShortName"></Option>
          </Select>
        </div>
      </FormItem>
      <FormItem label="上传文件:" prop="fileRule">
        <div class="flex" style="justify-content: flex-start;">
          <Input v-model="fileName" class="selectW80" readonly></Input>
          <Upload
            ref="upDateFile"
            style="margin-left: 10px;"
            :action="upDateFile"
            :format="['xlsx', 'xls', 'csv']"
            :headers="headers"
            :data="templateForm"
            :before-upload="beforeUpdateTemplate"
            :on-success="UpdateTemplateSuccess"
            :on-format-error="UpdateTemplateError"
            :show-upload-list="false"
          >
            <Button>浏览</Button>
          </Upload>
        </div>
      </FormItem>
      <h5>批量导入结果:</h5>
      <div>{{importResult}}</div>
      <div v-if="batchNumber!=''"><a @click="exportImpRes" class="mr20 colorBlue">导出导入结果</a></div>
      <div class="flex">
        <Button type="primary" @click="handleSubmit('templateForm')" :loading="btnloading">确定</Button>
        <Button @click="cancelSubmit">取消</Button>
      </div>
    </Form>
  </Modal>
</template>

<script>
import Cookies from "js-cookie";
import { TOKEN_KEY } from "@/libs/util";
import * as api from "@/api/shoppingCart/shoppingCart.js";
import urlObj from '@/config/env.js'
export default {
  name: "importXLS",
  props: {
    // eslint-disable-next-line
    URL: ""
  },
  data() {
    const validateUpload = (rule, value, callback) => {
      if (value && value.name) {
        callback();
      } else {
        callback(new Error('请选择文件'));
      }
    }
    return {
      btnloading:false,
      data:[],
      templateUrl:'',
      templateModel: false, //模态框开关
      templateForm: {
        sellerTenantId: '',
        // id: '',
        fileRule: null
      },
      ruleValidate: {
        sellerTenantId: [
          {required: true, message: '请选择店铺', trigger: 'blur'}
        ],
        fileRule: [
          {required: true, validator: validateUpload, trigger: 'blur'}
        ],
      },
      file:null,
      fileName:'',
      headers: {
        Authorization: "Bearer " + Cookies.get(TOKEN_KEY)
      } ,//请求头
      loading:false,
      shopList:[],
      importResult:'',
      batchNumber:''
    };
  },
  computed: {
    upDateFile(){
      return `${urlObj.wss}wss-order/shopping/cart/upload/shoppings?sellerTenantId=${this.templateForm.sellerTenantId}`
    }
  },
  methods: {
    //打开模态框
    openModal() {
      this.$refs.templateForm.resetFields();
      this.importResult=''
      this.file = null;
      this.fileName= '';
      this.templateModel = true;
      // this.templateForm.id = "";
      // this.file = null;
      // this.fileName= '';
      this.getTemUrl()
    },
    //获取模板地址
    async getTemUrl(){
      let res=await api.getTemplateOfShopping();
      if(res.status){
        this.templateUrl=res.data;
      }
    },
    //下载模板
    downLoding() {
      location.href =this.templateUrl + "?access_token=" + Cookies.get(TOKEN_KEY);
    },
    // 远程搜索的方法
    remoteMethod(query){
      if(query&&query.trim()!=''){
        this.remoteRequest(query)
      }
    },
    // 获取店铺数据
    async remoteRequest(name){
      this.loading=true;
      let res=await api.getShopListByName({ name })
      if(res.status){
        this.shopList = res.data;
      }else{
        this.shopList = []
      }
      this.loading=false;
    },
    // 上传前的钩子 
    beforeUpdateTemplate(file) {
      console.log(file);
      let refs = this.$refs;
      refs.upDateFile.clearFiles();
      this.templateForm.fileRule = file;
      this.file = file
      this.fileName=file.name;
      return false;
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        this.btnloading = true
        if (valid) {
          this.$refs.upDateFile.post(this.file)
        }
        this.btnloading = false
      })
    },
    cancelSubmit(){
      this.templateModel = false;
      // this.templateForm.id = "";
      this.file = null;
      this.fileName= '';
      this.templateModel = false;
    },
    UpdateTemplateSuccess(res) {
      console.log(res);
      if (res.status) {
        // this.$refs.templateForm.resetFields();
        // // this.templateForm.id = "";
        // this.file = null;
        // this.fileName= '';
        this.batchNumber=res.data;
        this.cartGetResult(res.data)
        this.firstShopping()
        // this.templateModel = false;
        // this.$Message.success('上传成功');
        // // this.templateModel = false;
        // this.$emit('refush')
        
      }else{
        this.$Message.error(res.message);
      }
      this.btnloading = false
    },
    UpdateTemplateError() {
      this.$Message.error("上传失败");
      this.btnloading = false
    },
     firstShopping(){
      // let res = await api.firstShopping()
      // if (res.status) {
      this.$Message.success('上传成功');
      this.$emit('refush')
      // }
    },
    //获取批量导入结果
    async cartGetResult(batchNumber){
      let res=await api.cartGetResult({batchNumber})
      if(res.status){
        this.importResult=res.data;
        // this.$Message.success(this.importResult);
      }else{
        this.importResult=''
      }
    },
    exportImpRes(){
      // location.href=api.exportImpRes()+ "?access_token=" + Cookies.get(TOKEN_KEY);
      location.href=`${api.exportImpRes()}?batchNumber=${this.batchNumber}&access_token=${Cookies.get(TOKEN_KEY)}`
    },
    //上传之前清空
    beforeUpload() {
      this.$refs.upload.clearFiles();
    }
  }
};
</script>

<style scoped>
  .colorBlue{
    color: #118ee2;
  }
  .selectW80{
    width:80% !important;
  }
  .flex{
    width:100%;
    display:flex;
    flex-direction:row;
    justify-content: space-evenly;
  }
</style>
